import { TThunkAction } from '../../types/redux';
import { setTransactionId } from '../../actions/checkout';
import { resetWidget } from '../../actions/common';
import { selectBalance, selectIsUseBalanceFunds, selectTransactionId } from '../../selectors/checkout';
import { getResultCancel } from '../../utils/result';
import { sendEvent } from '../../utils/sendEvent';
import { bindEvent } from '../../utils/bindEvent';

export const beforePaymentThunk: TThunkAction<Promise<void>> = async (dispatch, getState, context) => {
  const { resolveWidgetResult } = context;

  const state = getState();
  const useBalance = selectIsUseBalanceFunds(state);
  const useBalanceAmount = selectBalance(state);
  const transactionId = selectTransactionId(state);

  if (transactionId) {
    return Promise.resolve();
  }

  const result = new Promise<void>((resolve, reject) => {
    const beforePaymentSuccess = bindEvent('payment-widget/before-payment-success', transactionId => {
      dispatch(setTransactionId(transactionId));

      unbindListeners();

      resolve();
    });

    const beforePaymentFail = bindEvent('payment-widget/before-payment-fail', () => {
      dispatch(resetWidget());

      unbindListeners();

      resolveWidgetResult(getResultCancel());

      reject();
    });

    function unbindListeners() {
      document.removeEventListener('payment-widget/before-payment-success', beforePaymentSuccess);
      document.removeEventListener('payment-widget/before-payment-fail', beforePaymentFail);
    }
  });

  sendEvent('payment-widget/before-payment', { useBalance, useBalanceAmount });

  return result;
};
